import { useEffect } from "react";
import { useDispatch } from 'react-redux'
import { Form, Input, Button, Select, Tooltip } from "antd";
import { BiInfoCircle } from 'react-icons/bi'
import styled from "styled-components";
import Swal from "sweetalert2";

import actions from "../../redux/actions";
import service from '../../service/Mgt-sensor-parameter';
import FormControl from "../../component/form/FormControl";

import moment from "moment";
import "moment/locale/th";
moment.locale("th");

const { Option } = Select;

const FormExtend = styled(FormControl)`
  display: flex;
  flex-wrap: wrap;
  border-radius: 99px;

  .form-item__eval-pattern{
    width: 100%;
  }
`;

export default function FormMgtParams(props) {
  const [form] = Form.useForm();
  const dispatch = useDispatch()

  useEffect(() => {
    const InitData = async () => {
      if (props.paramId) {
        let formData = await service.getDetailSensorParam(props.sensorId, props.paramId)
        form.setFieldsValue(formData ? {
          name : formData.name,
          pctChangeAlarm: formData.pct_change_alarm,
          dispName : formData.disp_name,
          baseMin : formData.base_min,
          baseMax : formData.base_max,
          evalPattern : formData.eval_pattern,
          allowPublic: formData.allow_public ? 1 : 0,
        } : {})
      }
    }
    InitData()
  }, [form, props.paramId, props.sensorId])

  const onFinish = async (values) => {
    if(values.pctChangeAlarm == '') values.pctChangeAlarm = null
    if(values.baseMin == '') values.baseMin = null
    if(values.baseMax == '') values.baseMax = null
    if(values.evalPattern == '') values.evalPattern = null

    if(props.paramId){
      let result = await service.update(props.sensorId, props.paramId, values)
      if(result){
        Swal.fire({
          title: "อัพเดทพารามิเตอร์สำเร็จ",
          icon: "success",
          showCancelButton: false,
          showConfirmButton: false,
          timer: 1500
      }).then(function() {
        props.fncRefresh()
        dispatch(actions.popup.toggleVisible(false))
      })
      }
    }else{
      let result = await service.create(props.sensorId, values)
      if(result){
        Swal.fire({
          title: "สร้างพารามิเตอร์สำเร็จ",
          icon: "success",
          showCancelButton: false,
          showConfirmButton: false,
          timer: 1500
      }).then(function() {
        window.location.reload()
        dispatch(actions.popup.toggleVisible(false))
      })

      }
    }
  }

  const formInput = () => {
    return (
      <>
        <Form.Item
          name={["name"]}
          className="form-item__name"
          label="ชื่อตัวแปรที่วัด(พารามิเตอร์)"
          rules={[{ required: true }]}
        >
          <Input autoComplete="off"/>
        </Form.Item>
        <Form.Item
          name={["dispName"]}
          className="form-item__disp-name"
          label="ชื่อที่ใช้แสดง"
          rules={[{ required: true }]}
        >
          <Input autoComplete="off"/>
        </Form.Item>
        <Form.Item
          name={["pctChangeAlarm"]}
          className="form-item__pcrt_pct-change-alarm"
          label="เตือนการเปลี่ยนแปลง(%)"
          rules={[{ required: true }]}
        >
          <Input autoComplete="off" onChange={(e) => {
            let value = e.target.value.replace(/[^0-9.]+/g, "");
            form.setFieldsValue({ pctChangeAlarm: value });
          }}/>
        </Form.Item>
        <Form.Item
          name={["allowPublic"]}
          className="form-item__allow-public"
          label="การอนุญาตให้มองเห็น"
          rules={[{ required: true }]}
        >
          <Select placeholder="กรุณาเลือก" allowClear>
            <Option value={1}>เปิดสาธารณะ</Option>
            <Option value={0}>ปิดสาธารณะ</Option>
          </Select>
        </Form.Item>
        <Form.Item name={["baseMin"]} className="form-item__base-min" label="ตัวแปร VarA"  help="ใช้สำหรับแทนค่าสูตรคำนวณค่าระดับน้ำ">
          <Input 
          suffix={
            <Tooltip title={`แทนค่าในสูตรคำนวณ`}>
              <BiInfoCircle style={{ color: 'rgba(0,0,0,.45)' }} />
            </Tooltip>
          }
          autoComplete="off" onChange={(e) => {
            let value = e.target.value.replace(/[^0-9.]+/g, "");
            form.setFieldsValue({ baseMin: value });
          }}
          />
        </Form.Item>
        <Form.Item name={["baseMax"]} className="form-item__base-max" label="ตัวแปร VarB" help="ใช้สำหรับแทนค่าสูตรคำนวณค่าระดับน้ำ">
          <Input
          suffix={
            <Tooltip title={`แทนค่าในสูตรคำนวณ`}>
              <BiInfoCircle style={{ color: 'rgba(0,0,0,.45)' }} />
            </Tooltip>
          }
          autoComplete="off" onChange={(e) => {
            let value = e.target.value.replace(/[^0-9.]+/g, "");
            form.setFieldsValue({ baseMax: value });
          }}
          />
        </Form.Item>
        <Form.Item
          name={["evalPattern"]}
          className="form-item__eval-pattern"
          label="สูตรคำนวณค่าระดับน้ำที่หักค่าเกณฑ์หักน้ำแล้ว"
          help="หมายเหตุ: ตัวแปรที่ใช้ได้ในสูตร มีดังต่อไปนี้ data (ค่าข้อมูลจากเซนเซอร์), VarA, VarB"
        >
          <Input
          suffix={
            <Tooltip title={`ตัวอย่าง : varA+((varB-varA)*data/100)`}>
              <BiInfoCircle style={{ color: 'rgba(0,0,0,.45)' }} />
            </Tooltip>
          }
          />
        </Form.Item>
        <Form.Item className="form-button">
          {props.paramId ? 
          (props.permission.indexOf('update') >= 0 ? (<Button className="form-item__btn-submit btn-primary" htmlType="submit">อัพเดทพารามิเตอร์</Button>) : (<></>))
          : 
          (props.permission.indexOf('create') >= 0 ? (<Button className="form-item__btn-submit btn-primary" htmlType="submit">สร้างพารามิเตอร์</Button>) : (<></>))}
          <Button className="form-item__btn-cancel btn-secondary"
           onClick={() => dispatch(actions.popup.toggleVisible(false))}
          >
            ยกเลิก
          </Button>
        </Form.Item>
      </>
    );
  };

  return (
    <FormExtend
      name={"form-mgt__params"}
      column={2}
      inputs={formInput}
      onFinish={props.onFinish ? props.onFinish : onFinish}
      form={form}
      className={props.className ? props.className : ""}
    />
  );
}
